import React from 'react';
import s from './style.module.scss';
import RightArrowIcon from './icons/RightArrowIcon';
import RetryIcon from './icons/RetryIcon';

const MultimodalCard = ({ cardInfo, status, onClick, onRetry }) => {
    const { title, description, type } = cardInfo;
    const isLoading = status === 'loading';
    const isError = status === 'error';
    const isSuccess = status === 'success';

    return (
        <div
            className={`${s['list-item']} ${s[`card-${type}`]} ${isLoading ? s['loading-item'] : ''} ${isError ? s['error-item'] : ''}`}
            onClick={() => {
                if (isLoading) return;
                if (isError) {
                    onRetry(type);
                    return;
                }
                onClick(cardInfo);
            }}
        >
            <div className={s['item-content']}>
                <div className={s['item-title']}>
                    <span className={s['title-text']}>{title}</span>

                    <div className={s['status-section']}>
                        {isLoading && (
                            <span className={s['loading-state']}>
                                <span className={s['loading-text']}>正在生成...</span>
                            </span>
                        )}
                        {isError && (
                            <span className={s['error-badge']}>
                                <span className={s['error-text']}>生成失败</span>
                            </span>
                        )}
                        {isSuccess && <span style={{ color: '#8C8C8C', fontSize: '12px' }}>AI生成</span>}
                    </div>

                    <div className={s['icon-section']}>
                        {isLoading && <div className={s['loading-spinner-icon']}></div>}
                        {isError && (
                            <span
                                className={s['retry-icon']}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onRetry(type);
                                }}
                                title="重试"
                            >
                                <RetryIcon width={18} height={18} />
                            </span>
                        )}
                        {!isLoading && !isError && (
                            <span className={s['arrow-icon']}>
                                <RightArrowIcon />
                            </span>
                        )}
                    </div>
                </div>
                <div className={s['item-description']}>{description}</div>
            </div>
        </div>
    );
};

export default MultimodalCard;
